<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark :color="pages.header.back" fixed>
          <v-btn icon dark @click="$emit('fechar-modal','false')">
            <v-icon :class="pages.header.class">close</v-icon>
          </v-btn>
          <v-toolbar-title :class="pages.header.class">Minha Conta</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn :class="pages.header.class" dark flat @click="$emit('deslogar-usuario','false')">Sair</v-btn>
          </v-toolbar-items>
          <template v-slot:extension>
            <v-tabs v-model="conteudo.sessao" centered :color="pages.header.back" slider-color="white">
              <v-tab :class="pages.header.class" @click="$emit('click-em-tab',0)">
                Meus Pedidos
              </v-tab>
              <v-tab :class="pages.header.class" @click="$emit('click-em-tab',1)">
                Dados Pessoais
              </v-tab>
            </v-tabs>
          </template>
        </v-toolbar>
        <div style="padding-top: 120px;"></div>
        <v-tabs-items v-model="conteudo.sessao" v-if="parseInt(conteudo.sessao)>=0">
          <v-tab-item :key="0">
            <v-card flat>
              <v-card-text>
                <template v-if="conteudo.pedidos && !conteudo.pedidoAberto">
                  <template v-for="pedido in conteudo.pedidos.pedidos">
                    <div class="elevation-1 mb-3 py-4 px-1" @click="$emit('ver-pedido',pedido.id)">
                      <v-layout>
                        <v-flex xs4 class="text-xs-center">
                          <div class="subheading">
                            {{pedido.dataDesmembrada.data.d}}
                          </div>
                          <div class="caption">
                            {{pedido.dataDesmembrada.data.m}}/{{pedido.dataDesmembrada.data.y}}
                          </div>
                        </v-flex>
                        <v-flex xs8>
                          <v-layout>
                            <v-flex class="text-xs-center">
                              ID: {{pedido.id}}<br>
                              {{conteudo.pedidos.labelStatus[pedido.situacao]}}
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </div>
                  </template>
                </template>
                <template v-else-if="!conteudo.pedidos && conteudo.sessao==-1">
                  Você não tem pedidos registrados
                </template>
                <template v-else-if="conteudo.pedidoAberto">
                  <v-dialog
                      v-model="cancelarPedido.open"
                      max-width="290"
                    >
                    <v-card>
                      <v-card-title class="headline">Cancelar Pedido</v-card-title>
                      <v-card-text>
                        Deseja mesmo cancelar seu pedido?
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          color="primary darken-1"
                          flat="flat"
                          @click="cancelarPedido.open = false"
                        >
                          Não
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary darken-1"
                          flat="flat"
                          @click="confirmarCancelamentoDePedido"
                        >
                          Sim
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-btn @click="$emit('fechar-pedido')" block outline color="grey"><v-icon>close</v-icon><span>Voltar para lista de Meus pedidos</span></v-btn><br>
                  <v-alert v-if="conteudo.pedidoAberto.situacao && conteudo.pedidoAberto.situacao==2 && info.naopagamento && info.naopagamento.msg && info.naopagamento.msg!=''" :value="true" color="warning" icon="error" outline><span class="font-weight-bold" v-html="info.naopagamento.msg"></span></v-alert>
                  <v-alert :value="true" color="info" icon="error_outline" outline>Qualquer alteração no status do seu pedido será enviada por e-mail. Fique atento a sua caixa de entrada e ao lixo eletrônico (SPAM)</v-alert>
                  <span class="subheading font-weight-bold">Detalhes do Pedido:</span><br>
                  Itens:<br>
                    <template v-for="produto in conteudo.pedidoAberto.doc.itens">
                      <v-card class="my-1">
                        <v-card-text>
                          <div class="subheading">{{produto.nome}}</div>
                          <template v-if="produto.variacao && produto.variacao.value">
                            <template v-for="(variacao,varsIndex) in produto.variacao.value" v-if="produto.variacao!=false && produto.variacao!='false'" class="grey-text">
                              <span v-if="varsIndex"><br></span>{{variacao.nome}}<span v-if="variacao.valor && parseFloat(variacao.valor)>0">
                          <span v-if="variacao.val=='alt'" v-html="': R$ '+parseFloat(variacao.valor).toFixed(2).replace('.',',')"></span>
                          <span v-else-if="variacao.val=='add'" v-html="' (+ R$ '+parseFloat(variacao.valor).toFixed(2).replace('.',',')+')'"></span>
                        </span>
                            </template>
                          </template>
                          <div class="grey--text caption">
                            <span v-if="produto.valorcomadd && produto.valor<produto.valorcomadd">
                              Valor produto: R$ {{parseFloat(produto.valor).toFixed(2).replace(".",",")}} - 
                            </span>
                            <template v-for="(opcional,OplIndex) in produto.opcionais" class="grey-text">
                              <span v-if="OplIndex">, </span>{{opcional.nome}}<span v-if="opcional.valor">(R$: {{parseFloat(opcional.valor).toFixed(2).replace(".",",")}})</span>
                            </template>
                          </div>
                          <v-layout>
                            <v-flex xs7>
                              <span v-if="produto.valorcomadd">
                                R$ {{parseFloat(produto.valorcomadd).toFixed(2).replace(".",",")}}
                              </span>
                              <span v-else>
                                R$ {{parseFloat(produto.valor).toFixed(2).replace(".",",")}}
                              </span>
                               x {{ produto.qtd }}
                            </v-flex>
                            <v-flex xs>
                              <div class="text--primary text-xs-right">
                                <strong>R$ {{parseFloat(produto.subtotal).toFixed(2).replace(".",",")}}</strong>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </template>
                  <v-layout>
                    <v-flex>
                      ID: {{conteudo.pedidoAberto.id}}
                    </v-flex>
                    <v-flex class="text-xs-right">
                      Total: R$ {{parseFloat(conteudo.pedidoAberto.doc.total.pedido).toFixed(2).replace(".",",")}}
                    </v-flex>
                  </v-layout>
                  <!-- <div class="text-xs-center">{{conteudo.pedidos.labelStatus[conteudo.pedidoAberto.situacao]}}</div> -->
                  <template v-if="conteudo.pedidoAberto.doc.entrega.entrega=='true'">
                    <span class="subheading font-weight-bold">Entrega:</span><br>
                    Endereço: {{conteudo.pedidoAberto.doc.entrega.endereco}}<br>
                    Número: {{conteudo.pedidoAberto.doc.entrega.numero}} - 
                    Complemento: {{conteudo.pedidoAberto.doc.entrega.complemento}}<br>
                    Bairro: {{conteudo.pedidoAberto.doc.entrega.bairro.nome}}<br>
                    <v-alert v-if="conteudo.pedidoAberto.doc.entrega.estimativa" :value="true" color="warning" icon="warning" outline><span class="subheading font-weight-bold">Previsão de entrega:</span><br>
                    <template v-if="conteudo.pedidoAberto.doc.entrega.estimativa.mensagem">
                      <span v-html="conteudo.pedidoAberto.doc.entrega.estimativa.mensagem"></span>
                    </template>
                    <template v-else>
                      (* após confirmação do pagamento)<br>{{conteudo.pedidoAberto.doc.entrega.estimativa.diasemana}}, {{conteudo.pedidoAberto.doc.entrega.estimativa.datad.data.d}}/{{conteudo.pedidoAberto.doc.entrega.estimativa.datad.data.m}}/{{conteudo.pedidoAberto.doc.entrega.estimativa.datad.data.y}} ({{conteudo.pedidoAberto.doc.entrega.estimativa.dias}} dias)
                    </template>
                    </v-alert>
                    <template v-if="conteudo.pedidoAberto.doc.entrega.bairro.atendido=='null'">
                      * Verificando possibilidade de atender este bairro (sujeito a taxa)<br>
                    </template>
                    <template v-if="conteudo.pedidoAberto.doc.entrega.data_cliente">
                      <span class="font-weight-bold" v-html="'Data escolhida para entrega: '"></span>
                      <div class="text-xs-right" v-html="date_br(conteudo.pedidoAberto.doc.entrega.data_cliente)"></div>
                    </template>
                  </template>
                  <template v-else>
                    <span class="subheading font-weight-bold">Retirado no local:</span><br>
                    {{conteudo.pedidoAberto.doc.entrega.nome}}<br>
                    <template v-if="conteudo.pedidoAberto.doc.entrega.obs!=''">
                      ({{conteudo.pedidoAberto.doc.entrega.obs}})<br>
                    </template>
                    <template v-if="conteudo.pedidoAberto.doc.entrega.retirada">
                      <div v-if="conteudo.pedidoAberto.doc.entrega.retirada.endereco" v-html="conteudo.pedidoAberto.doc.entrega.retirada.endereco"></div>
                      <div v-if="conteudo.pedidoAberto.doc.entrega.retirada.numero && conteudo.pedidoAberto.doc.entrega.retirada.numero!=''" v-html="'Número: '+conteudo.pedidoAberto.doc.entrega.retirada.numero"></div>
                      <div v-if="conteudo.pedidoAberto.doc.entrega.retirada.complemento && conteudo.pedidoAberto.doc.entrega.retirada.complemento!=''" v-html="'Complemento: '+conteudo.pedidoAberto.doc.entrega.retirada.complemento"></div>
                      <div v-if="conteudo.pedidoAberto.doc.entrega.retirada.bairro.nome" v-html="'Bairro: '+conteudo.pedidoAberto.doc.entrega.retirada.bairro.nome"></div>
                    </template>
                  </template>
                  <template v-if="conteudo.pedidoAberto.doc.opcoesDeEntrega && conteudo.pedidoAberto.doc.opcoesDeEntrega.length>0">
                    <div class="font-weight-bold">Opções:</div>
                    <template v-for="opcaodeentrega in conteudo.pedidoAberto.doc.opcoesDeEntrega" v-html="opcaodeentrega+' - ')">
                      <div v-if="typeof opcaodeentrega == 'string'" v-html="opcaodeentrega"></div>
                      <div v-else-if="typeof opcaodeentrega == 'object' && opcaodeentrega.campo && opcaodeentrega.valor" v-html="opcaodeentrega.campo+': '+opcaodeentrega.valor"></div>
                    </template>
                    <br>
                  </template>
                  <template v-if="conteudo.pedidoAberto.doc.obs!=''">
                    <span class="font-weight-bold">Observações:</span> {{conteudo.pedidoAberto.doc.obs}}<br>
                  </template>
                  <div class="text-xs-right">
                    Taxa de Entrega: R$ {{parseFloat(conteudo.pedidoAberto.doc.total.entrega).toFixed(2).replace(".",",")}}
                    <br>
                    <template v-if="conteudo.pedidoAberto.doc.total.desconto && parseFloat(conteudo.pedidoAberto.doc.total.desconto)>0">
                      Desconto: R$ {{parseFloat(conteudo.pedidoAberto.doc.total.desconto).toFixed(2).replace(".",",")}}
                      <span v-if="conteudo.pedidoAberto.doc.cupom && parseInt(conteudo.pedidoAberto.doc.cupom)>0">(Cupom)</span>
                      <br>
                    </template>
                    <span class="subheading">
                      Total a Pagar: R$ {{parseFloat(conteudo.pedidoAberto.doc.total.pagar).toFixed(2).replace(".",",")}}
                    </span>
                    <br>
                    <template v-if="conteudo.pedidoAberto.situacao=='2'">
                        <v-btn color="success" :href="baseUrlPagar+conteudo.pedidoAberto.id+'/'+conteudo.pedidoAberto.doc.token" target="_blank" block>Pagar</v-btn>
                      <v-btn flat color="secondary" block @click="cliqueEmCancelarPedido(conteudo.pedidoAberto.id)">Cancelar</v-btn>
                    </template>
                  </div>
                </template>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :key="1">
            <v-card flat>
              <v-card-text>
                <template v-if="dadosPessoais.form.aberto">
                  <v-form ref="form" v-model="dadosPessoais.form.valid" lazy-validation>
                    
                    <v-select v-if="dadosPessoais.form.doc.documento && dadosPessoais.form.doc.documento.tipo" label="Tipo do Cadastro" v-model="dadosPessoais.form.doc.documento.tipo" :items="[{text:'Pessoa Física',value:'CPF'},{text:'Pessoa Jurídica',value:'CNPJ'}]" @change="editandoDadosPessoais()"></v-select>

                    <v-text-field v-if="!dadosPessoais.form.doc.documento || (dadosPessoais.form.doc.documento.tipo && dadosPessoais.form.doc.documento.tipo=='CPF')" v-model="dadosPessoais.form.name" :counter="50" :rules="dadosPessoais.form.nameRules" label="Nome Completo" required @keyup="editandoDadosPessoais()"></v-text-field>
                    <v-text-field v-else-if="dadosPessoais.form.doc.documento && dadosPessoais.form.doc.documento.tipo && dadosPessoais.form.doc.documento.tipo=='CNPJ'" v-model="dadosPessoais.form.name" :counter="50" :rules="dadosPessoais.form.nameRules" label="Razão Social" required @keyup="editandoDadosPessoais()"></v-text-field>
                   
                    <v-text-field v-model="dadosPessoais.form.whatsapp" :rules="dadosPessoais.form.whatsappRules" label="Whatsapp(DDD+Número)" required @keyup="editandoDadosPessoais()"></v-text-field>
                    
                    <template v-if="dadosPessoais.form.doc.documento">
                      <v-text-field v-if="(dadosPessoais.form.doc.documento.tipo && dadosPessoais.form.doc.documento.tipo=='CPF')" v-model="dadosPessoais.form.doc.documento.numero" label="CPF(Números)" required @keyup="editandoDadosPessoais()"></v-text-field label="Whatsapp(DDD+Número)" required @keyup="editandoDadosPessoais()"></v-text-field>
                      <v-text-field v-else-if="dadosPessoais.form.doc.documento.tipo && dadosPessoais.form.doc.documento.tipo=='CNPJ'" v-model="dadosPessoais.form.doc.documento.numero" label="CNPJ(Números)" required @keyup="editandoDadosPessoais()"></v-text-field label="Whatsapp(DDD+Número)" required @keyup="editandoDadosPessoais()"></v-text-field>
                    </template>
                    <v-text-field v-else v-model="dadosPessoais.form.cpf" :rules="dadosPessoais.form.cpfRules" label="CPF(Números)" required @keyup="editandoDadosPessoais()"></v-text-field label="Whatsapp(DDD+Número)" required @keyup="editandoDadosPessoais()"></v-text-field>
                    
                    <v-text-field v-if="!dadosPessoais.form.doc.documento || (dadosPessoais.form.doc.documento.tipo && dadosPessoais.form.doc.documento.tipo=='CPF')" v-model="dadosPessoais.form.doc.nascimento" type="date" label="Data de Nascimento" required @keyup="editandoDadosPessoais()"></v-text-field>

                    <div class="text-xs-center">
                      <v-btn color="error" @click="cancelarEdicaoDeDadosPessoais">Cancelar</v-btn>
                      <v-btn v-if="dadosPessoais.form.editando" :disabled="!dadosPessoais.form.valid" color="success" @click="atualizarDadosPessoais">Atualizar</v-btn>
                    </div>
                  </v-form>
                </template>
                <template v-else-if="editarSenha.open">
                  <div class="title">Editar Senha:</div>
                  <v-form ref="form" v-model="editarSenha.valid" lazy-validation>
                    <v-text-field v-model="editarSenha.form.senha" :rules="editarSenha.senhaRules" type="password" label="Informe senha atual" required></v-text-field>
                    <v-text-field v-model="editarSenha.form.novasenha" :rules="editarSenha.senhaRules" type="password" label="Informe a nova senha" required></v-text-field>
                    <v-text-field v-model="editarSenha.form.novasenhac" :rules="editarSenha.senhaRules" type="password" label="Confirme a nova senha" required></v-text-field>
                    <div class="text-xs-center">
                      <v-btn color="error" @click="editarSenha.open=false">Cancelar</v-btn>
                      <v-btn v-if="editarSenha.form.senha.length>4&&editarSenha.form.novasenha.length>4&&editarSenha.form.novasenhac.length>4" :disabled="!editarSenha.valid" color="success" @click="alterarSenha()">Atualizar</v-btn>
                    </div>
                  </v-form>
                </template>
                <template v-else-if="editarEmail.open">
                  <div class="title">Editar Email:</div>
                  <template v-if="editarEmail.codigo">
                    <div class="mt-2"><span class="subheading">Email: </span>{{editarEmail.formCod.novoemail}}</div>
                    <v-text-field v-model="editarEmail.formCod.codigo" label="Informe o código de Verificação" type="password" required></v-text-field>
                    <div class="text-xs-center">
                      <v-btn color="error" @click="editarEmail.open=false">Cancelar</v-btn>
                      <v-btn :disabled="editarEmail.formCod.codigo.length==0||editarEmail.formCod.codigo==''" color="success" @click="alterarEmail2()">Alterar Email</v-btn>
                    </div>
                    <hr>{{editarEmail.formCod}}
                  </template>
                  <template v-else>
                    <v-form ref="form" v-model="editarEmail.valid" lazy-validation>
                      <v-text-field v-model="editarEmail.form.emailnovo" :rules="editarEmail.emailRules" label="E-mail" required></v-text-field>
                      <v-text-field v-model="editarEmail.form.senha" :rules="editarSenha.senhaRules" type="password" label="Informe sua senha" required></v-text-field>
                      <div class="text-xs-center">
                        <v-btn color="error" @click="editarEmail.open=false">Cancelar</v-btn>
                        <v-btn :disabled="!editarEmail.valid" color="success" @click="alterarEmail()">Atualizar</v-btn>
                      </div>
                    </v-form>
                  </template>
                </template>
                <template v-else-if="conteudo.dadosPessoais">
                  <div class="title">Dados Pessoais:</div>
                  Nome: {{conteudo.dadosPessoais.nome}}<br>
                  Whatsapp: {{conteudo.dadosPessoais.whatsapp}}
                  <div class="text-xs-right">
                      <v-btn color="grey" block outline @click="btnGroupEditarDados=!btnGroupEditarDados">
                        <template v-if="btnGroupEditarDados">
                          Cancelar <v-icon right>close</v-icon>
                        </template>
                        <template v-else>
                          Editar <v-icon right>edit</v-icon>
                        </template>
                      </v-btn>
                  </div>
                  <div class="text-xs-center" v-if="btnGroupEditarDados">
                    
                      <v-btn color="primary" class="mx-0" @click="abrirEdicaoDeDadosPessoais" block outline>Editar Dados</v-btn>
                      <v-btn color="primary" class="mx-0" @click="editarSenha.open=true" block outline>Editar Senha</v-btn>
                      <v-btn color="primary" class="mx-0" @click="editarEmail.open=true" block outline>Editar Email</v-btn>
                   
                  </div>
                </template>
                <div class="title mb-2">Endereços:</div>
                <template v-if="conteudo.dadosPessoais">
                  <v-card class="mb-2" v-for="endereco in conteudo.dadosPessoais.enderecos">
                  <!-- Card para editar endereços -->
                    <template v-if="enderecos.form.atualizar.id==endereco.id">
                      <v-card-text class="pb-0">
                        <!-- INICIO EDIÇÃO -->
                        <div class="xs-12">
                            <v-flex xs12>
                              <v-text-field
                                label="Cep"
                                v-model="enderecos.form.atualizar.cep"
                              ></v-text-field>
                            </v-flex>
                            
                          <div class="text-xs-center" v-if="loader.bairrosatendidos">
                            <v-progress-circular
                              indeterminate
                              color="secondary"
                            ></v-progress-circular>
                            <div class="text-xs-center success--text">Carregando bairros...</div>
                          </div>
                          <v-autocomplete v-else v-model="enderecos.form.atualizar.bairro"
                                          :items="enderecos.form.novo.bairros"
                                          :label="'Bairro'"
                                          @change="selecionouBairro(enderecos.form.atualizar.bairro)"
                                        ></v-autocomplete>
                          <v-flex xs-12 v-if="enderecos.form.atualizar.bairro==='0' && enderecos.form.novo.bairrosnaoatendidos">
                            <div class="text-xs-center" v-if="loader.bairrosnaoatendidos">
                              <v-progress-circular
                                indeterminate
                                color="secondary"
                              ></v-progress-circular>
                              <div class="text-xs-center success--text">Carregando bairros...</div>
                            </div>
                            <v-autocomplete v-else v-model="enderecos.form.atualizar.bairronovo"
                                          :items="enderecos.form.novo.bairrosnaoatendidos"
                                          :label="'Bairro(Solicitar Atendimento)'"
                                        ></v-autocomplete>
                          </v-flex>
                          <v-flex xs-12>
                            <v-textarea
                              color="teal"
                              rows="3"
                              v-model="enderecos.form.atualizar.endereco"
                            >
                              <template v-slot:label>
                                <div>
                                  Endereço
                                </div>
                              </template>
                            </v-textarea>
                          </v-flex>
                          <v-layout>
                            <v-flex xs6>
                              <v-text-field
                                label="Número"
                                v-model="enderecos.form.atualizar.numero"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                label="Complemento"
                                v-model="enderecos.form.atualizar.complemento"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </div>
                        <!-- FIM EDIÇÃO -->
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" small @click="fecharEdicaoDeEndereco()">Cancelar</v-btn>
                        <v-btn color="primary" small @click="atualizarEndereco()">Atualizar</v-btn>
                      </v-card-actions>
                    </template>
                  <!--
                    -->
                  <!-- Card para listar os endereços -->
                    <template v-else>
                      <v-card-text class="pb-0">
                          <span class="grey--text">Cep: </span>
                          <span>{{endereco.cep}}</span><br>
                          <span class="grey--text">Bairro: </span>
                          <span>{{endereco.bairro_nome}}</span><br>
                          <span class="grey--text">Endereço: </span>
                          <span>{{endereco.endereco}}</span><br>
                          <span class="grey--text">Número: </span>
                          <span>{{endereco.numero}}</span>
                          <span class="grey--text"> - Complemento: </span>
                          <span>{{endereco.complemento}}</span>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <!--
                        <v-btn flat color="grey" small @click="removerEndereco(endereco.id)">Remover</v-btn>
                        -->
                        <v-btn flat color="grey" small @click="abrirEdicaoDeEndereco(endereco)">Editar</v-btn>
                      </v-card-actions>
                    </template>
                  </v-card>
                </template>
                <!-- Card para form cad novo enderaço -->
                <v-card v-if="enderecos.form.novo.open">
                  <v-card-title class="pb-0">
                    Novo endereço:
                  </v-card-title>
                  <v-card-text class="py-0">
                    <div class="xs-12">
                      <v-flex xs12>
                        <v-text-field
                          label="Cep"
                          v-model="enderecos.form.novo.cep"
                        ></v-text-field>
                      </v-flex>
                      <div class="text-xs-center" v-if="loader.bairrosatendidos">
                        <v-progress-circular
                          indeterminate
                          color="secondary"
                        ></v-progress-circular>
                        <div class="text-xs-center success--text">Carregando bairros...</div>
                      </div>
                      <v-autocomplete v-else v-model="enderecos.form.novo.bairro"
                                      :items="enderecos.form.novo.bairros"
                                      :label="'Bairro(atendido)'"
                                      @change="selecionouBairro(enderecos.form.novo.bairro)"
                                    ></v-autocomplete>
                      <v-flex xs-12 v-if="enderecos.form.novo.bairro==='0' && enderecos.form.novo.bairrosnaoatendidos">
                        <div class="text-xs-center" v-if="loader.bairrosnaoatendidos">
                          <v-progress-circular
                            indeterminate
                            color="secondary"
                          ></v-progress-circular>
                          <div class="text-xs-center success--text">Carregando bairros...</div>
                        </div>
                        <v-autocomplete v-else v-model="enderecos.form.novo.bairronovo"
                                      :items="enderecos.form.novo.bairrosnaoatendidos"
                                      :label="'Bairro(Solicitar Atendimento)'"
                                    ></v-autocomplete>
                      </v-flex>
                      <v-flex xs-12>
                        <v-textarea
                          color="teal"
                          rows="3"
                          v-model="enderecos.form.novo.endereco"
                        >
                          <template v-slot:label>
                            <div>
                              Endereço
                            </div>
                          </template>
                        </v-textarea>
                      </v-flex>
                      <v-layout>
                        <v-flex xs6>
                          <v-text-field
                            label="Número"
                            v-model="enderecos.form.novo.numero"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            label="Complemento"
                            v-model="enderecos.form.novo.complemento"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="enderecos.form.novo.open=!enderecos.form.novo.open">Cancelar</v-btn>
                    <v-btn color="primary" @click="cadastrarNovoEndereco()">Salvar</v-btn>
                  </v-card-actions>
                </v-card>
                <div v-else class="text-xs-right mt-2">
                  <v-item-group>
                  <!-- <v-btn class="mx-0" small flat>Removidos<v-icon>delete</v-icon></v-btn> -->
                  <v-btn class="mx-0" @click="cliqueEmCadastrarNovoEndereco" color="grey" block outline>Novo<v-icon right>add</v-icon></v-btn>
                  </v-item-group>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
  import jquery from 'jquery';
  export default {
    props:['dialog','conteudo','baseUrlApi','baseUrlPagar','pages','info'],
    data () {
      return {
        loader: {
          bairrosatendidos: false,
          bairrosnaoatendidos: false
        },
        dadosPessoais: {
          form: {
            aberto: false,
            editando: false,
            valid: true,
            name: '',
            nameRules: [
              v => !!v || 'Name is required',
              v => (v && v.length <= 50) || 'Name must be less than 10 characters'
            ],
            whatsapp: "",
            whatsappRules: [
              v => !!v || "Whatsapp obrigatório",
              v => (v && v.length >= 10 && v.length <= 12) || "Somente números(Ex.: 21987654321)"
            ],
            cpf: "",
            cpfRules: [
              v => !!v || "CPF obrigatório",
              v => (v && v.length == 11) || "Somente números(11 dígitos)"
            ],
            doc:{}
          }
        },
        enderecos: {
          form:{
            novo:{
              open: false,
              bairro: null,
              cep: "",
              bairronovo: "",
              endereco: "",
              numero: "",
              complemento: "",
              bairros:[],
              bairrosnaoatendidos:[]
            },
            atualizar:{
              id: 0,
              bairro: 0,
              cep: "",
              bairronovo: "",
              endereco: "",
              numero: "",
              complemento: "",
              bairros:[]
            }
          }
        },
        editarEmail:{
          open: false,
          valid: false,
          form:{emailnovo:"",senha:""},
          codigo: false,
          formCod:{codigo: "",emailnovo:""},
          emailRules: [
            v => !!v || "E-mail obrigatório",
            v => /.+@.+/.test(v) || "Insira um E-mail válido"
          ]
        },
        editarSenha:{
          open: false,
          valid: false,
          form:{novasenha: "",novasenhac:"",senha:""},
          senhaRules: [
            v => !!v || "Senha obrigatória",
            v => (v && v.length >= 5) || "Senha com no mínimo 5 caracteres"
          ]
        },
        btnGroupEditarDados: false,
        cancelarPedido: {
          open: false,
          id: null
        }
      }
    },
    methods:{
      validate() {
        if (this.$refs.form.validate()) {
          this.snackbar = true;
        }
      },
      cliqueEmCancelarPedido(pedido){
        this.cancelarPedido.open = true;
        this.cancelarPedido.id = pedido;
      },
      confirmarCancelamentoDePedido(){
        jquery.post(this.baseUrlApi+'pedidos/cancelarPedido',{id: this.cancelarPedido.id})
          .then(response =>(this.resposta_confirmarCancelamentoDePedido(response)));
      },
      resposta_confirmarCancelamentoDePedido(response){
        if(response.situacao==true){
          this.cancelarPedido.open = false;
          this.cancelarPedido.id = null;
          this.$emit('cancelando-pedido',true,response);
        }else{
          this.$emit('cancelando-pedido',false,response);
        }
      },
      editandoDadosPessoais(){
        if(this.dadosPessoais.form.editando){
          return;
        }
        this.dadosPessoais.form.editando = true;
        //console.log("Editando");
      },
      cancelarEdicaoDeDadosPessoais(){
        //this.$refs.form.reset()
        this.$refs.form.resetValidation()
        //this.dadosPessoais.form.editando = false;
        this.dadosPessoais.form.aberto = false;
      },
      abrirEdicaoDeDadosPessoais(){
        this.dadosPessoais.form.name = this.conteudo.dadosPessoais.nome;
        this.dadosPessoais.form.whatsapp = this.conteudo.dadosPessoais.whatsapp;
        this.dadosPessoais.form.cpf = this.conteudo.dadosPessoais.cpf;
        this.dadosPessoais.form.doc = this.conteudo.dadosPessoais.doc;
        this.dadosPessoais.form.aberto=true
        //console.log("Pronto para editar");
      },
      atualizarDadosPessoais () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
          //console.log("pode atualizar");
          jquery.post(this.baseUrlApi+'cadastroDeUsuario/dadosPessoais',{
            //dadosPessoais: JSON.stringify({
                                  nome: this.dadosPessoais.form.name,
                                  cpf: this.dadosPessoais.form.cpf,
                                  whatsapp: this.dadosPessoais.form.whatsapp,
                                  doc: JSON.stringify(this.dadosPessoais.form.doc)
             //                   })
          }).then(response =>(this.$emit('dados-pessoais-atualizados',response),this.cancelarEdicaoDeDadosPessoais()));
        }
      },
      selecionouBairro(bairro){
        if(bairro == '0'){// && this.enderecos.form.novo.bairrosnaoatendidos.length==0
          //console.log('atualizando');
           this.loader.bairrosnaoatendidos = true;
           jquery.get(this.baseUrlApi+'public_negocios/getBairrosNaoAtendidos/forSelect')
          .then(response =>(this.resposta_getBairrosNaoAtendidos(response)));
        }
      },
      resposta_getBairrosNaoAtendidos(response){
        this.loader.bairrosnaoatendidos = false;
        if(response.situacao == true){
          this.enderecos.form.novo.bairrosnaoatendidos = response.dados;
          this.enderecos.form.atualizar.bairrosnaoatendidos = response.dados;
        }
      },
      cadastrarNovoEndereco(){
      if(this.enderecos.form.novo.endereco==""){
        this.$emit("snackbar-alert","O campo Endereço é obrigatório.","error");
        return;
      }
      if(this.enderecos.form.novo.numero=="" && this.enderecos.form.novo.complemento==""){
        this.$emit("snackbar-alert","Você precisa informar, obrigatoriamente, o número ou o complemento.","error");
        return;
      }
        var dadosPost;
        dadosPost = {
          bairro: this.enderecos.form.novo.bairro,
          bairronovo: this.enderecos.form.novo.bairronovo,
          cep: this.enderecos.form.novo.cep,
          endereco: this.enderecos.form.novo.endereco,
          numero: this.enderecos.form.novo.numero,
          complemento: this.enderecos.form.novo.complemento
        };
        jquery.post(this.baseUrlApi+'cadastroDeUsuario/cadastroDeEndereco/cadastrar',dadosPost)
          .then(response =>(this.resposta_cadastrarNovoEndereco(response)));
      },
      resposta_cadastrarNovoEndereco(response){
        if(response.situacao==true){
          this.$emit('dados-pessoais-atualizados',response)
          this.enderecos.form.novo.bairro = null
          this.enderecos.form.novo.endereco = "";
          this.enderecos.form.novo.open = false;
        }else{
          this.$emit("snackbar-alert",response.mensagem,"error");
          //alert(response.mensagem);
        }
      },
      cliqueEmCadastrarNovoEndereco(){
        this.enderecos.form.novo.open=!this.enderecos.form.novo.open;
        if(this.enderecos.form.novo.open && this.enderecos.form.novo.bairros.length==0){
          this.loader.bairrosatendidos = true;
          jquery.post(this.baseUrlApi+'public_negocios/getBairrosAtendidos/forSelect')
          .then(response =>(
            this.enderecos.form.novo.bairros=response.dados,
            this.loader.bairrosatendidos = false
          ));
        }
      },
      abrirEdicaoDeEndereco(endereco){
        this.loader.bairrosatendidos = true;
        this.enderecos.form.atualizar.id = endereco.id;
        this.enderecos.form.atualizar.cep = endereco.cep;
        this.enderecos.form.atualizar.endereco = endereco.endereco;
        this.enderecos.form.atualizar.bairro = endereco.bairro_id;
        this.enderecos.form.atualizar.numero = endereco.numero;
        this.enderecos.form.atualizar.complemento = endereco.complemento;
        jquery.post(this.baseUrlApi+'public_negocios/getBairrosAtendidos/forSelect')
        .then(response =>(this.abrindoEdicaoDeEndereco(response.dados,endereco)));
      },
      abrindoEdicaoDeEndereco(dados,endereco){
        this.loader.bairrosatendidos = false;
        this.enderecos.form.novo.bairros=dados;
      },
      fecharEdicaoDeEndereco(){
        this.enderecos.form.atualizar.id = 0;
        this.enderecos.form.atualizar.endereco = "";
        this.enderecos.form.atualizar.cep = "";
        this.enderecos.form.atualizar.bairro = null;
        this.enderecos.form.atualizar.numero = "";
        this.enderecos.form.atualizar.complemento = "";
      },
      atualizarEndereco(){
      if(this.enderecos.form.atualizar.endereco==""){
        this.$emit("snackbar-alert","O campo Endereço é obrigatório.","error");
        return;
      }
      if(this.enderecos.form.atualizar.numero=="" && this.enderecos.form.atualizar.complemento==""){
        this.$emit("snackbar-alert","Você precisa informar, obrigatoriamente, o número ou o complemento.","error");
        return;
      }
        jquery.post(this.baseUrlApi+'cadastroDeUsuario/cadastroDeEndereco/atualizar',this.enderecos.form.atualizar)
         .then(response =>(this.resposta_atualizarEndereco(response)));
         //.then(response =>(//console.log(response)));
      },
      resposta_atualizarEndereco(response){
        if(response.situacao==true){
          this.fecharEdicaoDeEndereco();
          this.$emit('dados-pessoais-atualizados',response);
        }else{
          this.$emit("snackbar-alert",response.mensagem,"error");
        }
      },/*
      removerEndereco(id){
        console.log('Remover endereco: '+id);
      }, */
      alterarSenha(){
        if(this.editarSenha.form.novasenha==this.editarSenha.form.novasenhac){
          jquery.post(this.baseUrlApi+'cadastroDeUsuario/alterarSenha',
            this.editarSenha.form
            ).then(response =>(this.resposta_alterarSenha(response)));
        }else{
          //console.log("Os campos 'Nova Senha' e 'Confirme a Nova Senha' não correspondem");
        }
      },
      resposta_alterarSenha(response){
        if(response.situacao){
          this.editarSenha.open = false;
          //console.log(response.mensagem);
        }else{
          //console.log(response.mensagem);
        }
      },
      alterarEmail(){
        jquery.post(this.baseUrlApi+'cadastroDeUsuario/alterarEmail',
            this.editarEmail.form
            ).then(response =>(this.resposta_alterarEmail(response)));
      },
      resposta_alterarEmail(response){
        //console.log(response);
        if(response.situacao){
          //this.editarEmail.open = false;
          this.editarEmail.codigo = true;
          this.editarEmail.formCod.novoemail = this.editarEmail.form.emailnovo;
          //console.log(response.mensagem);
        }else{
          //console.log(response.mensagem);
        }
      },
      alterarEmail2(){
        jquery.post(this.baseUrlApi+'cadastroDeUsuario/efetivarAlteracaoDeEmail',
            this.editarEmail.formCod
            ).then(response =>(this.resposta_alterarEmail2(response)));
      },
      resposta_alterarEmail2(response){
        //console.log(response);
        if(response.situacao){
          this.editarEmail.open = false;
          this.editarEmail.codigo = false;
        }
      },
      date_br(data) {
        var ano  = data.split("-")[0];
        var mes  = data.split("-")[1];
        var dia  = data.split("-")[2];

        return ("0"+dia).slice(-2) + '/' + ("0"+mes).slice(-2) + '/' + ano;
      }
    }
  }
</script>
<style>
  #create .v-speed-dial {
    position: absolute;
  }
  #create .v-btn--floating {
    position: relative;
  }
</style>